module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av588-723df40b5f45ba9d2bba70d7c2b0824d.jpg";